import { render } from "./err.vue?vue&type=template&id=3fb2545b&ts=true"
import script from "./err.vue?vue&type=script&lang=ts"
export * from "./err.vue?vue&type=script&lang=ts"

import "./err.vue?vue&type=style&index=0&id=3fb2545b&lang=css"

import exportComponent from "E:\\weaving-project\\梭织 - 旧版PC端\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__